/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Client from 'fierry/flux/entity/client';

import Zoom from 'galax/client/zoom';

import HexGeometry from 'galax/client/geometry/hex';
import ZoneGeometry from 'galax/client/geometry/zone';
import FlightGeometry from 'galax/client/geometry/flight';


export default new Client ([ Zoom ], class
{
  constructor (zoom)
  {
    this.zoom = zoom;

    this.hex = new HexGeometry(zoom.getValue());
  }


  getHex ()
  {
    return this.hex;
  }


  getZone (location)
  {
    const planet = location.getPlanet();

    return planet ? planet.getGeometry(this.zoom.getValue()).getZone(location) : new ZoneGeometry(location, this);
  }


  getFlight (source, target)
  {
    return new FlightGeometry(source, target, this);
  }


});
